import { createContext, useContext } from 'react';

export type MembershipPaymentMode = 'new' | 'renew';

export interface OpenMembershipPaymentOptions {
  mode?: MembershipPaymentMode;
  currentPlanExpireAt?: string | null;
  initialPlanCode?: string;
}

export interface PaymentModalActions {
  // 会员权益不足时拉起会员开通/续费弹窗。
  openMembershipPaymentModal: (options?: OpenMembershipPaymentOptions) => void;
  // 算力豆入口展示明细，算力豆不足时可直接拉起购买弹窗。
  openComputePowerDetailModal: () => void;
  openComputePowerPurchaseModal: () => void;
  openComputePowerRulesModal: () => void;
}

export const PaymentModalContext = createContext<PaymentModalActions | null>(null);

export function usePaymentModals() {
  const context = useContext(PaymentModalContext);
  if (!context) {
    throw new Error('usePaymentModals 必须在 MainLayout 内使用');
  }
  return context;
}
